import type { FC, SVGProps } from 'react';
import React from 'react';

type IconProps = SVGProps<SVGSVGElement>;

export const PictureInPictureIcon: FC<IconProps> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="3.5"
      y="4.5"
      width="13"
      height="11"
      rx="1.5"
      stroke="white"
      strokeOpacity="0.8"
    />
    <rect
      x="8"
      y="9"
      width="7"
      height="5"
      rx="1"
      fill="white"
      fillOpacity="0.8"
    />
  </svg>
);
